<template>
  <b-container fluid class="p-3">
    <b-row class="p-3" v-if="skeletonloading">
      <b-col lg="8" md="8">
        <div class="asset-stats-card">
          <Skeleton height="1.5rem" width="100%" class="mb-4"></Skeleton>
          <div class="d-flex justify-content-around">
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
            <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4">
        <div class="details-card">
          <Skeleton height="1.5rem" width="100%" class="mb-5"></Skeleton>
          <b-row>
            <b-col lg="6" md="6" v-for="item in 4">
              <div class="quickcreatecard p-0">
                <Skeleton height="5rem" width="100%" class="mb-2"></Skeleton>
                <Skeleton height="2rem" width="100%" class="mb-5"></Skeleton>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <!-- {{ DetailsData }} -->
      <b-col lg="8" md="8" sm="12" cols="12">
        <div class="asset-stats-card" v-if="!skeletonloading">
          <h6 class="stats-title">
            {{ t("assetManagement.assetDetails.heading") }}
          </h6>
          <div class="stats-grid">
            <div class="stat-item" @click="openCardSidebar('card1')">
              <i class="pi pi-box"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.total") }}:</span
              >
              <span class="stat-value total">
                {{ DetailsData?.TotalAsset || 0 }}</span
              >
            </div>
            <div class="stat-item" @click="openCardSidebar('card2')">
              <i class="pi pi-cog"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.inuse") }}:</span
              >
              <span class="stat-value in-use">{{
                DetailsData?.AssetInUse || 0
              }}</span>
            </div>
            <div class="stat-item" @click="openCardSidebar('card3')">
              <i class="pi pi-check-circle"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.available") }}:</span
              >
              <span class="stat-value assigned">{{
                DetailsData?.AssetAvailability || 0
              }}</span>
            </div>
            <div class="stat-item">
              <i class="pi pi-wrench"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.maintenance") }}:</span
              >
              <span class="stat-value unassigned">{{
                DetailsData?.MaintenaceDue || 0
              }}</span>
            </div>
            <div class="stat-item" @click="openCardSidebar('card5')">
              <i class="pi pi-truck"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.InTransit") }}:</span
              >
              <span class="stat-value total">{{
                DetailsData?.AssetInTransit || 0
              }}</span>
            </div>
            <div class="stat-item">
              <i class="pi pi-trash"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.Disposed") }}:</span
              >
              <span class="stat-value assigned">{{
                DetailsData?.AssetDisposal || 0
              }}</span>
            </div>
            <div class="stat-item" @click="openCardSidebar('card7')">
              <i class="pi pi-calendar"></i>
              <span class="stat-label"
                >{{
                  t("assetManagement.assetDetails.WarrantyExpirations")
                }}:</span
              >
              <span class="stat-value unassigned">{{
                DetailsData?.warrantyExpirations || 0
              }}</span>
            </div>
            <div class="stat-item">
              <i class="pi pi-question-circle"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.ServiceRequests") }}:</span
              >
              <span class="stat-value in-use">{{
                DetailsData?.ExpiringAgreementsCount || 0
              }}</span>
            </div>
            <div class="stat-item" @click="openCardSidebar('card9')">
              <i class="pi pi-shield"></i>
              <span class="stat-label"
                >{{ t("assetManagement.assetDetails.Insurance") }}:</span
              >
              <span class="stat-value total">{{
                DetailsData?.AssetInsurance || 0
              }}</span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="4" md="4" sm="12" cols="12">
        <div class="carddetails">
          <h6 class="ps-3 pt-2">Quick Access</h6>
          <div>
            <div class="individualcard">
              <div class="individualimg">
                <img src="../../../../../../../assets/Img/notification.svg" />
              </div>
              <p class="quickcardheader">
                {{ t("assetManagement.assetDetails.locationdetails") }}
              </p>
            </div>
            <div class="individualcard" @click="goassettrack">
              <div class="individualimg">
                <img src="../../../../../../../assets/Img/notification.svg" />
              </div>
              <p class="quickcardheader">
                {{ t("assetManagement.assetDetails.assettracking") }}
              </p>
            </div>
            <div class="individualcard" @click="gomaintenance">
              <div class="individualimg">
                <img src="../../../../../../../assets/Img/notification.svg" />
              </div>
              <p class="quickcardheader">
                {{ t("assetManagement.assetDetails.assetmaintenance") }}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Right Sidebar Component -->
    <AssetDetailsRightSidebar
      :isOpen="sidebarOpen"
      :selectedAsset="selectedAsset"
      @close="closeSidebar"
    />
  </b-container>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import AssetMasterService from "../../../../../Service/AssetManagement/AssetMasterService";
import AssetDetailsRightSidebar from "./AssetDetailsRightSidebar.vue";

export default defineComponent({
  components: {
    AssetDetailsRightSidebar,
  },
  setup() {
    const { t } = useI18n();
    const skeletonloading = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const DetailsData = ref();
    const sidebarOpen = ref(false);
    const selectedAsset = ref<any>(null);
    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
      BranchId: Number(routes.query.BranchId ?? 0),
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);

    async function IsShow() {
      try {
        skeletonloading.value = true;
        const dataresponse = await AssetMasterService.getListAssetDashBoard(
          HospitalId,
          ParamValues.value.BranchId,
          ParamValues.value.StoreId
        );
        DetailsData.value = dataresponse["result"];
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function goassettrack() {
      router.push({
        path: "/AssetTrackingReturnManagement",
        query: {
          data: JSON.stringify(ParamValues.value),
        },
      });
    }

    function closeSidebar() {
      sidebarOpen.value = false;
      selectedAsset.value = null;
    }

    function openCardSidebar(cardType: string) {
      console.log("Card clicked:", cardType);

      const cardData = {
        cardType: cardType,
        data: {
          title: getCardTitle(cardType),
          type: cardType,
        },
      };

      selectedAsset.value = cardData;
      sidebarOpen.value = true;

      console.log("Sidebar should be open now:", sidebarOpen.value);
      console.log("Selected asset:", selectedAsset.value);
    }

    function getCardTitle(cardType: string) {
      switch (cardType) {
        case "card1":
          return "Total Assets Overview";
        case "card2":
          return "Assets In Use";
        case "card3":
          return "Asset Availability Analysis";
        case "card5":
          return "Assets in Transit";
        case "card7":
          return "Expiring Warranties";
        case "card9":
          return "Insured Assets";
        default:
          return "Asset Details";
      }
    }

    onMounted(() => {
      IsShow();
    });

    function gomaintenance() {
      router.push({
        path: "/assetmaintenancedashboard",
        query: {
          StoreId: ParamValues.value.StoreId,
          BranchId: ParamValues.value.BranchId,
        },
      });
    }

    return {
      skeletonloading,
      goassettrack,
      ParamValues,
      t,
      DetailsData,
      HospitalId,
      sidebarOpen,
      selectedAsset,
      closeSidebar,
      openCardSidebar,
      gomaintenance,
    };
  },
});
</script>

<style scoped>
.asset-stats-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.stats-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  align-items: start;
}

.stat-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-height: 70px;
  cursor: pointer;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-item i {
  font-size: 24px;
  /* color: #007bff; */
  margin-right: 12px;
  min-width: 32px;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  margin-right: 8px;
  flex: 1;
  font-weight: 500;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  min-width: 40px;
  text-align: center;
}
.pi-trash {
  color: #6c6c6c;
}
.stat-value.total {
  color: #28a745;
}

.stat-value.unassigned {
  color: #ffc107;
}

.stat-value.assigned {
  color: #17a2b8;
}

.stat-value.in-use {
  color: #dc3545;
}

.carddetails {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.individualcard {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.individualcard:hover {
  background-color: #f8f9fa;
}

.individualcard:last-child {
  border-bottom: none;
}

.individualimg {
  margin-right: 12px;
}

.individualimg img {
  width: 24px;
  height: 24px;
}

.quickcardheader {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .asset-stats-card {
    padding: 16px;
  }

  .stat-item {
    padding: 12px;
  }
}

@media (max-width: 576px) {
  .stat-item {
    flex-direction: column;
    text-align: center;
    min-height: auto;
  }

  .stat-item i {
    margin-right: 0;
    margin-bottom: 8px;
  }

  .stat-label {
    margin-right: 0;
    margin-bottom: 4px;
  }

  .stat-value {
    text-align: center;
  }
}
</style>
